///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { BomSummaryRecordDTO } from '../bom-summary.models';
import { isDefined } from '@siklu/sui-lib/utils';
import { SuiTypeNumber } from '@siklu/sui-lib/infrastructure';
import { GtthHistoryService } from '../../../logical-topology/engine/history-service';

@Component({
    selector: 'winde-bom-summary-record-table',
    templateUrl: 'bom-summary-record-table.component.html',
    styleUrls: ['bom-summary-record-table.scss'],
    standalone: false
})
export class BomSummaryRecordTableComponent implements OnInit, OnChanges {
    @Input() summaryRecordsList: Record<string, BomSummaryRecordDTO>[];
    @Input() showInstalled = false;
    @Input() currencyCode: string;

    @Output() discountChanged: EventEmitter<BomSummaryRecordDTO> = new EventEmitter<BomSummaryRecordDTO>();

    public recordsToShow: { discountControl: SuiTypeNumber; record: BomSummaryRecordDTO }[];

    constructor(private readonly historyService: GtthHistoryService) {}

    ngOnInit(): void {
        this.recalculateRecordsToShow();
    }

    ngOnChanges(): void {
        this.recalculateRecordsToShow();
    }

    private recalculateRecordsToShow(): void {
        this.recordsToShow = [];

        this.summaryRecordsList.forEach((summaryRecordsObject: Record<string, BomSummaryRecordDTO>) => {
            if (!isDefined(summaryRecordsObject)) {
                return;
            }
            for (const summaryRecordKey in summaryRecordsObject) {
                const summaryRecord = summaryRecordsObject[summaryRecordKey];
                if (this.showInstalled ? summaryRecord.installedCount : summaryRecord.count) {
                    this.recordsToShow.push({
                        record: summaryRecord,
                        discountControl: this.createDiscountControl(summaryRecord)
                    });
                }
            }
        });

        this.recordsToShow.sort((a, b) => a.record.order - b.record.order);
    }

    private createDiscountControl(summaryRecord: BomSummaryRecordDTO): SuiTypeNumber {
        const discountControl = new SuiTypeNumber(
            summaryRecord.discount,
            summaryRecord.discount,
            this.historyService.logicalTopology.basic_discount ?? 0,
            100
        );
        discountControl.readonly = !this.historyService.isEditModeEnabled;

        discountControl.valueChangedCallback = (newDiscount: number) => {
            if (discountControl.valid()) {
                this.historyService.logicalTopology.products_discounts[summaryRecord.name] = newDiscount;
                summaryRecord.discount = newDiscount;
            } else {
                summaryRecord.discount = 0;
            }

            this.discountChanged.emit(summaryRecord);
        };

        return discountControl;
    }
}
